import { useI18n } from '@/lib/i18n';
import MoneyBack from '@images/Money-Back.png';
import Retention from '@images/Retention.png';
import Support from '@images/Support.png';

export default function OurGuaranteesSection() {
  const { t } = useI18n();

  return (
    <section className="relative bg-white">
      <div className="mx-auto max-w-screen-lg p-6 md:py-12 lg:py-20">
        <h2 className="text-center text-4xl font-semibold tracking-tight text-balance text-black sm:text-6xl">
          {t('components.our_guarantees.Our Rock-Solid Guarantees')}
        </h2>

        <p className="mx-auto mt-8 max-w-prose text-center text-lg font-medium text-pretty sm:text-xl">{t('components.our_guarantees.intro')}</p>

        <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center lg:mt-16 lg:gap-8">
          <div className="w-48 max-w-80 sm:w-full">
            <img src={Retention} className={'h-auto w-full rounded-4xl'} alt={t('components.our_guarantees.lifespan_title')} />
          </div>

          <div className={'flex-1'}>
            <h3 className={'text-xl font-semibold group-hover:underline sm:text-2xl'}>{t('components.our_guarantees.lifespan_title')}</h3>
            <p className="mt-2 text-gray-700 lg:text-lg">{t('components.our_guarantees.lifespan_text')}</p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-4 sm:flex-row-reverse sm:items-center lg:mt-16 lg:gap-8">
          <div className="w-48 max-w-80 sm:w-full">
            <img src={MoneyBack} className={'h-auto w-full rounded-4xl'} alt={t('components.our_guarantees.money_back_title')} />
          </div>

          <div className={'flex-1'}>
            <h3 className={'text-xl font-semibold group-hover:underline sm:text-2xl'}>{t('components.our_guarantees.money_back_title')}</h3>
            <p className="mt-2 text-gray-700 lg:text-lg">{t('components.our_guarantees.money_back_text_1')}</p>
            <p className="mt-2 text-gray-700 lg:text-lg">{t('components.our_guarantees.money_back_text_2')}</p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center lg:mt-16 lg:gap-8">
          <div className="w-48 max-w-80 sm:w-full">
            <img src={Support} className={'h-auto w-full rounded-4xl'} alt={t('components.our_guarantees.support_title')} />
          </div>

          <div className={'flex-1'}>
            <h3 className={'text-xl font-semibold group-hover:underline sm:text-2xl'}>{t('components.our_guarantees.support_title')}</h3>
            <p className="mt-2 text-gray-700 lg:text-lg">{t('components.our_guarantees.support_text_1')}</p>
            <p className="mt-2 text-gray-700 lg:text-lg">
              {t('components.our_guarantees.support_text_2')}{' '}
              <a href="mailto:info@boostbuddy.org" className={'underline'}>
                info@boostbuddy.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
